<router-outlet name="lightbox"></router-outlet>
<mb-archived-banner [displayDate]="magazine?.archiveDate ?? undefined" variant="content"></mb-archived-banner>
@if (activeStream$ | async; as activeStream) {
  <div
    class="magazine-video-wrapper"
    [class.stream-player-error-wrapper]="activeStream.playerConfig?.showErrorScreen"
    [@fadeInOut]
  >
    <mb-stream-player-wrapper
      [activeStream]="activeStream"
      [autoplay]="true"
      [transcript]="activeStream.video?.transcript || null"
      [showBackButton]="true"
      (backButton)="closePlayer()"
      (streamStopped)="streamStopped()"
      (openMedia)="openMediaFromTranscript($event)"
    ></mb-stream-player-wrapper>
    @if (activeStream.playerConfig?.externalPlayer) {
      <mb-external-player
        [embedCode]="$safeNavigationMigration(activeStream.playerConfig?.externalPlayer)"
        [title]="$safeNavigationMigration(activeStream.video?.title)"
        (backButton)="closePlayer()"
      ></mb-external-player>
    }
  </div>
}

@if (magazine) {
  @if (magazine.sections.length) {
    @for (
      section of magazine.sections;
      track section.id || section.topicId || section.anchor || section.type + '-' + $index;
      let index = $index
    ) {
      <mb-section
        mbRevealWhenVisible
        [index]="index"
        [data]="section"
        [show]="!section.hideInitially"
        (openMedia)="openMedia($event)"
        [ngClass]="section.lightBg ? 'bg-light' : 'bg-dark'"
      ></mb-section>
    }
  }
}
